import { render, staticRenderFns } from "./RequestPasswordReset.vue?vue&type=template&id=a96d5fdc"
import script from "./RequestPasswordReset.vue?vue&type=script&lang=js"
export * from "./RequestPasswordReset.vue?vue&type=script&lang=js"
import style0 from "./RequestPasswordReset.vue?vue&type=style&index=0&id=a96d5fdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/user/RequestPasswordReset.vue
// module id = null
// module chunks = 